import { useEffect } from "react"
import { Layout } from "@/components/layout"
import { ErrorView } from "@/components/error-fallback"
import { NotFound } from "@/components/not-found"
import { ApiError } from "@/lib/api"
import { Sentry } from "@/lib/sentry"

interface ErrorPageProps {
  error: unknown
}

export function ErrorPage({ error }: ErrorPageProps) {
  const isApiNotFound = error instanceof ApiError && error.status === 404

  useEffect(() => {
    if (isApiNotFound) return
    Sentry.captureException(error)
  }, [error, isApiNotFound])

  if (isApiNotFound) {
    return <NotFound />
  }

  if (import.meta.env.VITE_NODE_ENV !== "production") {
    throw error
  }

  return (
    <Layout>
      <ErrorView />
    </Layout>
  )
}
